import React, { Fragment } from 'react';
import ryanair from 'components/assets/img/logo/ryanair.svg';
import wizzair from 'components/assets/img/logo/wizzair.png';
import busIcon from 'components/assets/img/icons/bus.svg';
import moment from 'moment';
import {
  DIRECTION_ARRIVE, DIRECTION_FLIGHT,
  CARRIER_RYANAIR, CARRIER_WIZZAIR
} from 'components/components/booking/utils/FlightConstants';

function formatDuration(duration) {
  var minutes = duration.minutes();
  var hours = duration.hours();
  var text = '';
  if (hours > 0) {
    text += hours + "h ";
  }
  text += minutes + "min";
  return text;
}

function getBusStopName(busStops, busStopKey) {
  if (busStops && busStops[busStopKey]) {
    return busStops[busStopKey].name;
  } else {
    return busStopKey;
  }
}

function handleOnClick(e, flight, handler) {
  e.preventDefault();
  if (flight.is_blocked_in_pwa) {
    return false;
  } else {
    handler(flight);
  }
}

function ItemFlight(props) {
  var flight = props.flightObj;
  var busStops = props.busStops;
  var dateMoment = moment(flight.flight_date);
  var dateFormated = dateMoment.format("DD.MM.YYYY");
  var timetableData = flight.timetable_data;

  if (flight.direction === DIRECTION_FLIGHT) {
    var departure = getBusStopName(busStops, timetableData.bus_stop);;
    var arrival = flight.airport.name;
    var dateHoursFormated = timetableData.departure_time;
    var mirrorDateHours = timetableData.arrival_time;
  } else {
    var departure = flight.airport.name;
    var arrival = getBusStopName(busStops, timetableData.bus_stop);
    var dateHoursFormated = timetableData.departure_time;
    var mirrorDateHours = timetableData.arrival_time;
  }

  var duration = timetableData.driving_time * 60 * 1000; // duration (min) * 60seconds * 1000miliseconds
  var formattedDuration = formatDuration(moment.duration(duration));

  var cssClass = 'list-flights__item';
  if (flight.is_blocked_in_pwa) {
    cssClass = 'list-flights__item list-flights__item--blocked';
  } else if (props.active) {
    cssClass = 'list-flights__item list-flights__item--active';
  }

  return (
    <li className={cssClass} onClick={(e) => handleOnClick(e, flight, props.handleChange)}>
      <div className="list-flights__header">
        <p>{dateFormated}</p>
      </div>

      <div className="list-flights__flight-time">
        <p>{formattedDuration}&nbsp;</p>
      </div>

      <div className="list-flights__desc">
        <div className="list-flights__departure">
          <p className="list-flights__time">
            {
              dateHoursFormated
            }
          </p>
          <p>{departure}</p>
        </div>

        <div className="list-flights__icon">
          <span>
            <img src={busIcon} />
          </span>
        </div>

        <div className="list-flights__arrival">
          <p className="list-flights__time">
            {
              mirrorDateHours
            }
          </p>
          <p>{arrival}</p>
        </div>
      </div>
    </li>
  );
}

export default ItemFlight;
